import { Menu } from 'antd';
import { AppstoreOutlined, MailOutlined, SettingOutlined, PauseCircleOutlined } from '@ant-design/icons';
import React from 'react';
import './form-menu.css'
import listNumber from "./list-number";

const { SubMenu } = Menu;

// submenu keys of first level
const rootSubmenuKeys = ['sub1', 'sub2', 'sub3', 'sub4', 'sub5'];

const Sider = () => {
    const [openKeys, setOpenKeys] = React.useState(['sub1']);

    const onOpenChange = keys => {
        const latestOpenKey = keys.find(key => openKeys.indexOf(key) === -1);
        if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
            setOpenKeys(keys);
        } else {
            setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
        }
    };

    return (
        <Menu mode="inline" openKeys={openKeys} onOpenChange={onOpenChange}>
            <SubMenu key="sub1" icon={<></>} title={<a href="#basics">Survey basics</a>}>
                <Menu.Item key="1">Survey name</Menu.Item>
                <Menu.Item key="2">Survey association</Menu.Item>
                <Menu.Item key="3">Survey language</Menu.Item>
                <Menu.Item key="4">Target group</Menu.Item>
            </SubMenu>
            <SubMenu key="sub2"  icon={<></>} title={<a href="#details">Details</a>}>
                <Menu.Item key="5">Description</Menu.Item>
                <Menu.Item key="6">Detail 2</Menu.Item>
            </SubMenu>
            <SubMenu key="sub3" icon={<></>} title={<a href="#link">Link</a>}>
            </SubMenu>
            <SubMenu key="sub4" icon={<></>} title={<a href="#deadline">Deadline</a>} >
            </SubMenu>
            <SubMenu key="sub5"  icon={<></>} title={<a href="#termsofagreement">Terms of agreement</a>}>
            </SubMenu>
        </Menu>
    );
};

export default Sider;